import React from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  Grid,
  Paper,
  Button,
} from '@material-ui/core';

import MainLayout from '../../common/components/MainLayout';
import AboutUs from './AboutUs';
import Services from './Services';
import Team from './Team';
import Contact from './Contact';
import FAQs from './FAQs';

import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


const staticPages = (props) => {
  const activePage = props.match.params.page;

  let title = null;
  let content = null;

  if (activePage === 'about') {
    title = 'About Us';
    content = <AboutUs />;
  }

  if (activePage === 'services') {
    title = 'Services';
    content = <Services />;
  }

  if (activePage === 'team') {
    title = 'Team';
    content = <Team />;
  }

  if (activePage === 'contact') {
    title = 'Contact Us';
    content = <Contact />;
  }

  if (activePage === 'faqs') {
    title = 'FAQs';
    content = <FAQs />;
  }

  const tabs = (
    <div className={classes.searchTabsWrapper}>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'about' })}>
        <Button
          variant="outlined"
          className={activePage === 'about' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          About Us
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'services' })}>
        <Button
          variant="outlined"
          className={activePage === 'services' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Services
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'team' })}>
        <Button
          variant="outlined"
          className={activePage === 'team' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Team
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'contact' })}>
        <Button
          variant="outlined"
          className={activePage === 'contact' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          Contact
        </Button>
      </Link>
      <Link className={classes.linkDeCSS} to={formatRoute(routes.STATIC_PAGES, { page: 'faqs' })}>
        <Button
          variant="outlined"
          className={activePage === 'faqs' ? [classes.searchFormTabs, classes.active].join(' ') : classes.searchFormTabs}
        >
          FAQs
        </Button>
      </Link>
    </div>
  );

  let rootClass = null;
  if (props.isAuthenticated) {
    rootClass = classes.dashboardLayout;
  }

  return (
    <MainLayout rootClass={rootClass} isAuthenticated={props.isAuthenticated}>
      <Grid container style={{ justifyContent: 'center' }}>
        <Grid item md={8} sm={10} xs={12}>
          {tabs}
          <Paper className={[classes.card].join(' ')}>
            <Typography variant="headline">{title}</Typography>
            <span className={classes.titleUnderline} />
            {content}
          </Paper>
        </Grid>
      </Grid>
    </MainLayout>
  );
};


const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};


export default withRouter(connect(mapStateToProps, null)(staticPages));



// WEBPACK FOOTER //
// ./src/main/components/StaticPages.js